import React from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { useCurrentCompletedUser } from '@web/features/user/service';

import { EXPLAIN_BOOST_COMMAND } from '../commands';
import { BaseTile, CommandButton, CommandLineEntry } from '../common';
import { useTerminal } from '../TerminalProvider';
import { TimerMessage } from '../TimerMessage';

import VectorIcon from './Vector.svg?url';

import { StakingBoost } from '.';

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('1500')};
`;

const TimerTile = styled(BaseTile)`
  padding: ${({ theme }) => theme.spacing('2000')};
  align-items: center;
`;

const Counter = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing('0500')};

  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['10']};
`;

const IconImage = styled.img``;

export const ConnectedStakingBoost = () => {
  const t = useTranslations();
  const boosts = useCurrentCompletedUser()?.user.boosts ?? 0;
  const { processCommand } = useTerminal();

  const timerEnd = new Date('2025-10-31T21:59:59.000Z');

  return (
    <StakingBoost
      timer={
        <TimerTile>
          <TimerMessage endDate={timerEnd} onRunCommand={processCommand} />
        </TimerTile>
      }
      titleComponent={`${[t('STAKING_TERMINAL_BOOST_TITLE')]}`}
    >
      <BottomContent>
        <Counter>
          {boosts}
          <IconImage src={VectorIcon} />
        </Counter>
        <CommandLineEntry centered>
          {t.rich(EXPLAIN_BOOST_COMMAND.message, {
            button: (chunks) => (
              <CommandButton
                onClick={() => processCommand(EXPLAIN_BOOST_COMMAND)}
              >
                {chunks}
              </CommandButton>
            ),
          })}
        </CommandLineEntry>
      </BottomContent>
    </StakingBoost>
  );
};
